import React, { useState, useEffect } from "react";
import { baseUrl } from "../../helper/urls.js";
import axios from "axios";
import MasterLayout from "../../masterLayout/MasterLayout.jsx";
import CounselorCard from "./CounselorCard.jsx";
import FilterCounselor from "./FilterCounselor.jsx";
import { Box, CircularProgress, Typography } from "@mui/material";

const ApprovedCounselorGrid = ({ url }) => {
  // const [counselors, setCounselors] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // const fetchCounselors = async () => {
  //   setLoading(true);
  //   setError(null);
  //   try {
  //     const response = await axios.get(
  //       `${baseUrl}/api/${url || "counselors/approved"}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     setCounselors(response.data.data);
  //   } catch (err) {
  //     setError("Failed to load counselors. Please try again.");
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchCounselors();
  // }, []);

  return (
    <MasterLayout>
      <Box sx={{ mb: 0 }}>
        <FilterCounselor />
      </Box>

      {/* {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", mt: 5 }}>
          <Typography color="error">{error}</Typography>
        </Box>
      ) : (
        <CounselorCard counselors={counselors} />
      )} */}
    </MasterLayout>
  );
};

export default ApprovedCounselorGrid;

// import React, { useState, useEffect } from "react";
// import { baseUrl } from "../../helper/urls.js";
// import axios from "axios";
// import ApprovedCounselorCard from "./ApprovedCounselorCard.jsx";
// import MasterLayout from "../../masterLayout/MasterLayout.jsx";
// import Breadcrumb from "../../components/Breadcrumb.jsx";
// import CounselorCard from "./CounselorCard.jsx";
// import FilterCounselor from "./FilterCounselor.jsx";
// import { Box, CircularProgress } from "@mui/material";
// import DemoCounselor from "./DemoCounselor.jsx";
// const ApprovedCounselorGrid = ({ url }) => {
//   const [counselors, setCounselors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchCounselors = async () => {
//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/${url || "counselors/approved"}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       setCounselors(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       setError(error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCounselors();
//     setLoading(false);
//   }, []);

//   return (
//     <>
//       <MasterLayout>
//         {/* Breadcrumb */}
//         {/* <Breadcrumb title="Select Counselors" /> */}
//         {/* <ApprovedCounselorCard counselors={counselors} /> */}
//         <Box sx={{ mb: 2 }}>
//           <FilterCounselor />
//           {/* <DemoCounselor /> */}
//         </Box>
//         {loading ? (
//           <CircularProgress />
//         ) : (
//           <CounselorCard counselors={counselors} />
//         )}
//       </MasterLayout>
//     </>
//   );
// };

// export default ApprovedCounselorGrid;

// import React, { useState, useEffect } from 'react';

// import { baseUrl } from "../../helper/urls.js"
// import axios from 'axios';
// import ApprovedCounselorCard from "./ApprovedCounselorCard.jsx";
// import MasterLayout from '../../masterLayout/MasterLayout.jsx';
// import Breadcrumb from '../../components/Breadcrumb.jsx';
// const ApprovedCounselorGrid = ({ url }) => {

//     const [counselors, setCounselors] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const fetchCounselors = async () => {
//         try {
//             const response = await axios.get(`${baseUrl}/api/${url || "counselors/approved"}`, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${sessionStorage.getItem('token')}`
//                 },
//             });
//             setCounselors(response.data.data);
//             setLoading(false);
//         } catch (error) {
//             setError(error);
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchCounselors();
//         setLoading(false);
//     }, []);

//     return (
//         <>
//               <MasterLayout>

//         {/* Breadcrumb */}
//         {/* <Breadcrumb title="Select Counselors" /> */}
//           <ApprovedCounselorCard counselors={counselors} />
//               </MasterLayout>

//         </>
//     );
// };

// export default ApprovedCounselorGrid;
